var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "form",
        {
          attrs: { autocomplete: "no" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              _vm.$emit("save")
            },
            keydown: function($event) {
              _vm.clearError($event)
            }
          }
        },
        [
          _c("div", { attrs: { id: "accordion-wrap" } }, [
            _c("div", { staticClass: "mobile-accordion" }, [
              _c(
                "div",
                {
                  ref: "addresses",
                  staticClass: "card-header",
                  attrs: {
                    id: "headingOne",
                    "data-toggle": "collapse",
                    "data-target": "#collapseOne",
                    "aria-expanded": "true",
                    "aria-controls": "collapseOne"
                  },
                  on: {
                    click: function($event) {
                      _vm.setOpenedAccordion(1)
                    }
                  }
                },
                [
                  _c("span", { staticClass: "mb-0" }, [
                    _vm._v("\n            Addresses\n          ")
                  ]),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "chevron-alt",
                    class: { rotate: _vm.expanded.includes(1) },
                    attrs: {
                      src: require("../../assets/img/chevron-alt.svg"),
                      alt: "chevron"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "collapse",
                  class: { show: _vm.jobTabStep === 1 },
                  attrs: {
                    id: "collapseOne",
                    "aria-labelledby": "headingOne",
                    "data-parent": "#accordion-wrap"
                  }
                },
                [
                  _c(
                    "section",
                    [
                      _c(
                        "div",
                        { staticClass: "row mb-4" },
                        [
                          _c("jobs-leads-addresses", {
                            attrs: {
                              data: _vm.job,
                              "has-access": _vm.hasAccess,
                              "show-dropdown": _vm.showDropdown,
                              permission: "jobs.route.update",
                              errors: _vm.errors
                            },
                            on: {
                              toggleEditField: _vm.toggleEditField,
                              setAddress: _vm.setAddress,
                              switchRoute: _vm.switchRoute,
                              addAddress: _vm.addAddress,
                              removeAddress: _vm.removeAddress
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.fileForDelete !== null
                        ? _c("AreYouSureDeleteFile", {
                            attrs: { job: _vm.job, file: _vm.fileForDelete },
                            on: {
                              close: function($event) {
                                _vm.fileForDelete = null
                              },
                              "reload-files": _vm.getFiles
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "row mb-3" }, [
                        _vm._m(0),
                        _vm._v(" "),
                        _vm.job.agreements.length
                          ? _c(
                              "div",
                              { staticClass: "col-12 pr-0 pb-3 border-bottom" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "flex flex-wrap" },
                                  _vm._l(_vm.job.agreements, function(
                                    agreement
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: agreement.id,
                                        staticClass:
                                          "d-flex flex cursor-pointer justify-content-center align-items-start mr-2 pt-2 px-2 border rounded file-card",
                                        on: {
                                          click: function($event) {
                                            _vm.openFile(agreement.url)
                                          }
                                        }
                                      },
                                      [
                                        _c("span", {
                                          staticClass: "mod-icon-doc mt-1"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex flex-column ml-1"
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "file-name" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    agreement.url.substring(
                                                      agreement.url.lastIndexOf(
                                                        "/"
                                                      ) + 1
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "file-date" },
                                              [_vm._v(_vm._s(agreement.date))]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  })
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 pr-0 mt-3" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-items-start justify-content-start flex-wrap"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "mb-3" },
                                [
                                  _c("UploadDocument", {
                                    attrs: { "model-id": _vm.job.id },
                                    on: { uploaded: _vm.getFiles }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm._l(
                                _vm.files.filter(function(file) {
                                  return !file.uploaded_by_customer
                                }),
                                function(file) {
                                  return _c(
                                    "div",
                                    {
                                      key: file.id,
                                      staticClass:
                                        "d-flex flex cursor-pointer justify-content-center align-items-start mr-2 pt-2 px-2 border rounded file-card"
                                    },
                                    [
                                      _c("span", {
                                        class: {
                                          "mod-icon-doc mt-1": !file.mime.includes(
                                            "image"
                                          ),
                                          "mod-icon-img": file.mime.includes(
                                            "image"
                                          )
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.openFile(file.url)
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex flex-column ml-1",
                                          on: {
                                            click: function($event) {
                                              _vm.openFile(file.url)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "file-name" },
                                            [_vm._v(_vm._s(file.name))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "file-date" },
                                            [_vm._v(_vm._s(file.date))]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center ml-3",
                                          staticStyle: { height: "40px" }
                                        },
                                        [
                                          _c("span", {
                                            class: {
                                              "mod-icon-eye-state":
                                                file.can_see_customer,
                                              "mod-icon-eye-off-state": !file.can_see_customer
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "buttons-box" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center justify-content-center mx-1 ml-3",
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  _vm.updateFileCanCustomerSee(
                                                    file
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("span", {
                                                class: {
                                                  "mod-icon-eye": !file.can_see_customer,
                                                  "mod-icon-eye-off":
                                                    file.can_see_customer
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "mx-1 remove-file-block",
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  _vm.fileForDelete = file
                                                }
                                              }
                                            },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "mod-icon-remove-file"
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }
                              )
                            ],
                            2
                          )
                        ]),
                        _vm._v(" "),
                        _vm.files.filter(function(file) {
                          return file.uploaded_by_customer
                        }).length > 0
                          ? _c(
                              "div",
                              {
                                staticClass: "col-12 pr-0 mt-3 pt-3 border-top"
                              },
                              [
                                _c(
                                  "h2",
                                  { staticClass: "mb-2 documents-title" },
                                  [_vm._v("Uploaded by customer")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex align-items-start justify-content-start flex-wrap"
                                  },
                                  _vm._l(
                                    _vm.files.filter(function(file) {
                                      return file.uploaded_by_customer
                                    }),
                                    function(file) {
                                      return _c(
                                        "div",
                                        {
                                          key: file.id,
                                          staticClass:
                                            "d-flex flex cursor-pointer justify-content-center align-items-start mr-2 pt-2 px-2 border rounded file-card"
                                        },
                                        [
                                          _c("span", {
                                            class: {
                                              "mod-icon-doc mt-1": !file.mime.includes(
                                                "image"
                                              ),
                                              "mod-icon-img": file.mime.includes(
                                                "image"
                                              )
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.openFile(file.url)
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex flex-column ml-1",
                                              on: {
                                                click: function($event) {
                                                  _vm.openFile(file.url)
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "file-name" },
                                                [_vm._v(_vm._s(file.name))]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "file-date" },
                                                [_vm._v(_vm._s(file.date))]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "buttons-box" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "mx-1 ml-3 remove-file-block",
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      _vm.fileForDelete = file
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("span", {
                                                    staticClass:
                                                      "mod-icon-remove-file"
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    }
                                  )
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ],
                    1
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mobile-accordion" }, [
              _c(
                "div",
                {
                  ref: "location",
                  staticClass: "card-header",
                  attrs: {
                    id: "headingTwo",
                    "data-toggle": "collapse",
                    "data-target": "#collapseTwo",
                    "aria-expanded": "true",
                    "aria-controls": "collapseTwo"
                  },
                  on: {
                    click: function($event) {
                      _vm.setOpenedAccordion(2)
                    }
                  }
                },
                [
                  _c("span", { staticClass: "mb-0" }, [
                    _vm._v("\n            Location details\n          ")
                  ]),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "chevron-alt",
                    class: { rotate: _vm.expanded.includes(2) },
                    attrs: {
                      src: require("../../assets/img/chevron-alt.svg"),
                      alt: "chevron"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "collapse",
                  class: { show: _vm.jobTabStep === 2 },
                  attrs: {
                    id: "collapseTwo",
                    "aria-labelledby": "headingTwo",
                    "data-parent": "#accordion-wrap"
                  }
                },
                [
                  _c("section", [
                    _c("div", { staticClass: "row mb-3" }, [
                      _c(
                        "div",
                        {
                          staticClass: "map-job-wrapper col-lg-5 col-xl-6 pr-0"
                        },
                        [
                          _vm.showDisconnectError
                            ? _c("JobsMapConnectionIssue")
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.mapLoading,
                                expression: "!mapLoading"
                              }
                            ],
                            staticStyle: { width: "480px", height: "500px" },
                            attrs: { id: "mapid" }
                          }),
                          _vm._v(" "),
                          _vm.mapLoading
                            ? _c("div", { staticClass: "loader-circle" })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-lg-7 col-xl-6 mt-4 mt-lg-0 mt-md-0 mt-xl-0"
                        },
                        [
                          _c("Distance", {
                            attrs: { distance: _vm.job.distances }
                          }),
                          _vm._v(" "),
                          _vm.showTimeline
                            ? _c("JobInProgressMoveTimeline", {
                                attrs: {
                                  "status-id": _vm.job.status_id,
                                  "status-logs": _vm.job.status_logs,
                                  "status-name": _vm.job.status.name
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mobile-accordion" }, [
              _c(
                "div",
                {
                  ref: "movers",
                  staticClass: "card-header",
                  attrs: {
                    id: "headingThree",
                    "data-toggle": "collapse",
                    "data-target": "#collapseThree",
                    "aria-expanded": "true",
                    "aria-controls": "collapseThree"
                  },
                  on: {
                    click: function($event) {
                      _vm.setOpenedAccordion(3)
                    }
                  }
                },
                [
                  _c("span", { staticClass: "mb-0" }, [
                    _vm._v("\n            Movers & Trucks\n          ")
                  ]),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "chevron-alt",
                    class: { rotate: _vm.expanded.includes(3) },
                    attrs: {
                      src: require("../../assets/img/chevron-alt.svg"),
                      alt: "chevron"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "collapse",
                  class: { show: _vm.jobTabStep === 3 },
                  attrs: {
                    id: "collapseThree",
                    "aria-labelledby": "headingThree",
                    "data-parent": "#accordion-wrap"
                  }
                },
                [
                  _c(
                    "section",
                    { staticClass: "movers-truck-info" },
                    [
                      _vm.hasAccess
                        ? [
                            _c("div", [
                              _c("div", { staticClass: "row mb-3" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-12 col-xl-6 col-md-6 col-lg-6 movers-message"
                                  },
                                  [
                                    _c("h2", { staticClass: "l-header-2" }, [
                                      _c("span", {
                                        staticClass:
                                          "mod-icon mod-icon-groups-dark"
                                      }),
                                      _vm._v(
                                        "\n                      MOVERS\n                      "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "movers-truck-count" },
                                        [
                                          _vm._v(
                                            "\n                        " +
                                              _vm._s(
                                                Object.keys(
                                                  _vm.job.assigned_movers
                                                ).length
                                              )
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "message-wrap pull-right",
                                        on: {
                                          mouseover: function($event) {
                                            _vm.showTooltipPrefix = true
                                          },
                                          mouseout: function($event) {
                                            _vm.showTooltipPrefix = false
                                          }
                                        }
                                      },
                                      [
                                        _vm.isActive
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "btn send-to-all-box pull-right pointer",
                                                class: {
                                                  disabled:
                                                    !Object.keys(
                                                      _vm.job.assigned_movers
                                                    ).length ||
                                                    !_vm.carrierPhoneNumberCheck()
                                                },
                                                on: {
                                                  click: function($event) {
                                                    _vm.$emit(
                                                      "sendAutomaticMessages",
                                                      Object.keys(
                                                        _vm.job.assigned_movers
                                                      ).length && true
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "send-to-all"
                                                  },
                                                  [_vm._v("A")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "send-to-all-text"
                                                  },
                                                  [_vm._v("Send to all")]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.showTooltipPrefix &&
                                    !Object.keys(_vm.job.assigned_movers).length
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "popover tippy-info-popover"
                                          },
                                          [
                                            _vm._v(
                                              "\n                      There are no movers assigned on this job, messages cannot be sent\n                    "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.showTooltipPrefix &&
                                    !_vm.carrierPhoneNumberCheck()
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "popover tippy-info-popover company-number-popup"
                                          },
                                          [
                                            _vm._v(
                                              "\n                      Company doesn’t have a phone number for sending SMS to movers\n                    "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.job.assigned_movers.length
                                      ? _c(
                                          "table",
                                          {
                                            staticClass:
                                              "table m-table table-hover"
                                          },
                                          [
                                            _vm._m(1),
                                            _vm._v(" "),
                                            _c(
                                              "tbody",
                                              _vm._l(
                                                _vm.job.assigned_movers,
                                                function(
                                                  assigned_mover,
                                                  index
                                                ) {
                                                  return _c(
                                                    "tr",
                                                    { key: assigned_mover.id },
                                                    [
                                                      _c(
                                                        "td",
                                                        { staticClass: "pl-0" },
                                                        [
                                                          _vm._v(
                                                            "\n                            " +
                                                              _vm._s(
                                                                assigned_mover.first_name
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                assigned_mover.last_name
                                                              ) +
                                                              "\n                            "
                                                          ),
                                                          assigned_mover.id ===
                                                          _vm.job.foreman_id
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  class: {
                                                                    "foreman-status-blue":
                                                                      assigned_mover.id ===
                                                                      _vm.job
                                                                        .foreman_id
                                                                  }
                                                                },
                                                                [_vm._v("F")]
                                                              )
                                                            : assigned_mover.foreman ===
                                                              true
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    class: {
                                                                      "foreman-status-grey":
                                                                        "assigned_mover.foreman === true"
                                                                    }
                                                                  },
                                                                  [_vm._v("F")]
                                                                )
                                                              : _vm._e()
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.job
                                                        .assigned_movers !== ""
                                                        ? _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "pl-0"
                                                            },
                                                            [
                                                              _vm.job
                                                                .assigned_movers[
                                                                index
                                                              ].confirmed ===
                                                              "pending"
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "message-status message-pending"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "send-to-all"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "A"
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "message-text message-pending-text"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Pending"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _vm.job
                                                                .assigned_movers[
                                                                index
                                                              ].confirmed ===
                                                              "declined"
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "message-status message-declined"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "send-to-all"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "A"
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "message-text message-text"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Declined"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _vm.job
                                                                .assigned_movers[
                                                                index
                                                              ].confirmed ===
                                                              "confirmed"
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "message-status message-confirmed"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "send-to-all"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "A"
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "message-text message-text"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Confirmed"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        { staticClass: "pl-0" },
                                                        [
                                                          assigned_mover.has_new_message ===
                                                          true
                                                            ? _c("div", {
                                                                staticClass:
                                                                  "dot-blue dot-blue-small pointer",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.toggleShowMessagesModal(
                                                                      assigned_mover.id
                                                                    )
                                                                  }
                                                                }
                                                              })
                                                            : _vm._e()
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        { staticClass: "pl-0" },
                                                        [
                                                          _vm._v(
                                                            "\n                            " +
                                                              _vm._s(
                                                                _vm.phoneMask.maskedPhone(
                                                                  assigned_mover.phone
                                                                )
                                                              ) +
                                                              "\n                          "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "pr-0 new-message-open align-items-center"
                                                        },
                                                        [
                                                          _vm.isActive
                                                            ? [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "send-to-mover",
                                                                    on: {
                                                                      mouseover: function(
                                                                        $event
                                                                      ) {
                                                                        _vm.showTooltipMoversPrefix = index
                                                                      },
                                                                      mouseout: function(
                                                                        $event
                                                                      ) {
                                                                        _vm.showTooltipMoversPrefix = false
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    !_vm
                                                                      .loadingButtonMovers[
                                                                      index
                                                                    ]
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "message-send-to-all pointer",
                                                                            class: [
                                                                              {
                                                                                running:
                                                                                  _vm
                                                                                    .loadingButtonMovers[
                                                                                    index
                                                                                  ]
                                                                              },
                                                                              {
                                                                                disabled:
                                                                                  !assigned_mover.phone ||
                                                                                  !_vm.carrierPhoneNumberCheck()
                                                                              }
                                                                            ],
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                _vm.sendMessages(
                                                                                  assigned_mover,
                                                                                  index
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "send-to-all"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "A"
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "ld ld-ball ld-flip send-messages-icon-loader"
                                                                          }
                                                                        )
                                                                  ]
                                                                )
                                                              ]
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "send-to-all-modal",
                                                              on: {
                                                                mouseover: function(
                                                                  $event
                                                                ) {
                                                                  _vm.showTooltipMoversPrefix = index
                                                                },
                                                                mouseout: function(
                                                                  $event
                                                                ) {
                                                                  _vm.showTooltipMoversPrefix = false
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "message-send-to-all pointer",
                                                                  class: {
                                                                    disabled:
                                                                      !assigned_mover.phone ||
                                                                      !_vm.carrierPhoneNumberCheck()
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.toggleShowMessagesModal(
                                                                        assigned_mover.id
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._m(
                                                                    2,
                                                                    true
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _vm.isActive ||
                                                          (_vm.isCompleted &&
                                                            _vm.$_can(
                                                              "movers.completed_job.edit"
                                                            ))
                                                            ? _c(
                                                                "button",
                                                                {
                                                                  staticClass:
                                                                    "btn btn-clear pointer pull-right",
                                                                  attrs: {
                                                                    type:
                                                                      "button"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.unassignMover(
                                                                        assigned_mover.id
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c("span", {
                                                                    staticClass:
                                                                      "mod-icon-clear"
                                                                  })
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _vm.showTooltipMoversPrefix ===
                                                            index &&
                                                          !_vm.carrierPhoneNumberCheck()
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "popover tippy-info-popover"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                              Company doesn’t have a phone number for sending SMS to movers\n                            "
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ],
                                                        2
                                                      )
                                                    ]
                                                  )
                                                }
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-12 col-xl-6 col-md-6 col-lg-6"
                                  },
                                  [
                                    _c("h2", { staticClass: "l-header-2" }, [
                                      _c("span", {
                                        staticClass:
                                          "mod-icon mod-icon-trucks-dark"
                                      }),
                                      _vm._v(
                                        "\n                      TRUCKS\n                      "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "movers-truck-count" },
                                        [
                                          _vm._v(
                                            "\n                        " +
                                              _vm._s(
                                                Object.keys(
                                                  _vm.job.assigned_trucks
                                                ).length
                                              )
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm.job.assigned_trucks.length
                                      ? _c(
                                          "table",
                                          {
                                            staticClass: "table m-table",
                                            class: {
                                              "table-hover": _vm.isActive
                                            }
                                          },
                                          [
                                            _vm._m(3),
                                            _vm._v(" "),
                                            _c(
                                              "tbody",
                                              _vm._l(
                                                _vm.job.assigned_trucks,
                                                function(assigned_truck) {
                                                  return _c(
                                                    "tr",
                                                    { key: assigned_truck.id },
                                                    [
                                                      _c(
                                                        "td",
                                                        { staticClass: "pl-0" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              assigned_truck.licence_plate
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        { staticClass: "pl-0" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              assigned_truck.name
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        { staticClass: "pr-0" },
                                                        [
                                                          _vm.isActive
                                                            ? _c(
                                                                "button",
                                                                {
                                                                  staticClass:
                                                                    "btn btn-clear pointer pull-right",
                                                                  attrs: {
                                                                    type:
                                                                      "button"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.unassignTruck(
                                                                        assigned_truck.id
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c("span", {
                                                                    staticClass:
                                                                      "mod-icon-clear"
                                                                  })
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                }
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _vm.isActive ||
                                (_vm.isCompleted &&
                                  _vm.$_can("movers.completed_job.edit"))
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-12 col-xl-6 col-md-6 col-lg-6"
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "add-button pointer",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function($event) {
                                                _vm.$emit(
                                                  "openAssignedMoversModal"
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._m(4),
                                            _vm._v(
                                              "\n                      Assign Mover\n                    "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isActive
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-12 col-xl-6 col-md-6 col-lg-6 mt-3 mt-lg-0 mt-xl-0 mt-md-0"
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "add-button pointer",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function($event) {
                                                _vm.$emit(
                                                  "openAssignedTrucksModal"
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._m(5),
                                            _vm._v(
                                              "\n                      Assign Truck\n                    "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ])
                          ]
                        : [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "container" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-12 d-flex flex-column align-items-center justify-content-center"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "access-image" },
                                      [_c("NoAccessImage")],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(
                                        "\n                      Sorry, you don't have access to this information.\n                    "
                                      )
                                    ])
                                  ]
                                )
                              ])
                            ])
                          ]
                    ],
                    2
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mobile-accordion" }, [
              _c(
                "div",
                {
                  ref: "plans",
                  staticClass: "card-header",
                  attrs: {
                    id: "headingFive",
                    "data-toggle": "collapse",
                    "data-target": "#collapseFive",
                    "aria-expanded": "true",
                    "aria-controls": "collapseFive"
                  },
                  on: {
                    click: function($event) {
                      _vm.setOpenedAccordion(5)
                    }
                  }
                },
                [
                  _c("span", { staticClass: "mb-0" }, [
                    _vm._v("\n            Plans\n          ")
                  ]),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "chevron-alt",
                    class: { rotate: _vm.expanded.includes(4) },
                    attrs: {
                      src: require("../../assets/img/chevron-alt.svg"),
                      alt: "chevron"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _vm.jobTabStep === 5
                ? _c(
                    "div",
                    {
                      staticClass: "collapse",
                      class: { show: _vm.jobTabStep === 5 },
                      attrs: {
                        id: "collapseFive",
                        "aria-labelledby": "headingFive",
                        "data-parent": "#accordion-wrap"
                      }
                    },
                    [
                      _c(
                        "section",
                        [
                          _vm.hasAccess
                            ? [
                                _c("div", { staticClass: "row mb-3" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-12" },
                                    [
                                      _c("JobPlans", {
                                        attrs: { job: _vm.job },
                                        on: {
                                          getJob: function($event) {
                                            _vm.$emit("getJob")
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            : [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "container" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-12 d-flex flex-column align-items-center justify-content-center"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "access-image" },
                                          [_c("NoAccessImage")],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("div", [
                                          _vm._v(
                                            "\n                      Sorry, you don't have access to this information.\n                    "
                                          )
                                        ])
                                      ]
                                    )
                                  ])
                                ])
                              ]
                        ],
                        2
                      )
                    ]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mobile-accordion" }, [
              _c(
                "div",
                {
                  ref: "log",
                  staticClass: "card-header",
                  attrs: {
                    id: "headingFour",
                    "data-toggle": "collapse",
                    "data-target": "#collapseFour",
                    "aria-expanded": "true",
                    "aria-controls": "collapseFour"
                  },
                  on: {
                    click: function($event) {
                      _vm.setOpenedAccordion(4)
                    }
                  }
                },
                [
                  _c("span", { staticClass: "mb-0" }, [
                    _vm._v("\n            Log\n          ")
                  ]),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "chevron-alt",
                    class: { rotate: _vm.expanded.includes(4) },
                    attrs: {
                      src: require("../../assets/img/chevron-alt.svg"),
                      alt: "chevron"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _vm.jobTabStep === 4
                ? _c(
                    "div",
                    {
                      staticClass: "collapse",
                      class: { show: _vm.jobTabStep === 4 },
                      attrs: {
                        id: "collapseFour",
                        "aria-labelledby": "headingFour",
                        "data-parent": "#accordion-wrap"
                      }
                    },
                    [
                      _c(
                        "section",
                        [
                          _vm.hasAccess
                            ? [
                                _c("div", { staticClass: "row mb-3" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-12" },
                                    [
                                      _c("JobLogs", { attrs: { job: _vm.job } })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            : [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "container" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-12 d-flex flex-column align-items-center justify-content-center"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "access-image" },
                                          [_c("NoAccessImage")],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("div", [
                                          _vm._v(
                                            "\n                      Sorry, you don't have access to this information.\n                    "
                                          )
                                        ])
                                      ]
                                    )
                                  ])
                                ])
                              ]
                        ],
                        2
                      )
                    ]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mobile-accordion" }, [
              _c(
                "div",
                {
                  ref: "fees-percentages",
                  staticClass: "card-header",
                  attrs: {
                    id: "headingSix",
                    "data-toggle": "collapse",
                    "data-target": "#collapseSix",
                    "aria-expanded": "true",
                    "aria-controls": "collapseSix"
                  },
                  on: {
                    click: function($event) {
                      _vm.setOpenedAccordion(6)
                    }
                  }
                },
                [
                  _c("span", { staticClass: "mb-0" }, [
                    _vm._v("\n            Fees & Percentages\n          ")
                  ]),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "chevron-alt",
                    class: { rotate: _vm.expanded.includes(6) },
                    attrs: {
                      src: require("../../assets/img/chevron-alt.svg"),
                      alt: "chevron"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _vm.jobTabStep === 6
                ? _c(
                    "div",
                    {
                      staticClass: "collapse",
                      class: { show: _vm.jobTabStep === 6 },
                      attrs: {
                        id: "collapseSix",
                        "aria-labelledby": "headingSix",
                        "data-parent": "#accordion-wrap"
                      }
                    },
                    [
                      _c(
                        "section",
                        [
                          _vm.hasAccess
                            ? [
                                _c("div", { staticClass: "row mb-3" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-12" },
                                    [
                                      _c("FeesPercentages", {
                                        attrs: {
                                          "cluster-fee": _vm.job.cluster_fee,
                                          "cluster-percent":
                                            _vm.job.cluster_percent,
                                          loading: _vm.jobLoading,
                                          "fee-change": _vm.job.fee_change,
                                          "job-id": _vm.job.id
                                        },
                                        on: {
                                          getJob: function($event) {
                                            _vm.$emit("getJob")
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            : [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "container" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-12 d-flex flex-column align-items-center justify-content-center"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "access-image" },
                                          [_c("NoAccessImage")],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("div", [
                                          _vm._v(
                                            "\n                      Sorry, you don't have access to this information.\n                    "
                                          )
                                        ])
                                      ]
                                    )
                                  ])
                                ])
                              ]
                        ],
                        2
                      )
                    ]
                  )
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _vm.editedField && _vm.isActive
            ? _c(
                "div",
                { staticClass: "row mx-0 position-fixed hidden-buttons" },
                [
                  _c("div", { staticClass: "col pb-2 pt-2 text-right" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary ld-ext-right",
                        class: _vm.loadingDiscardButton ? "running" : "",
                        attrs: { type: "button" },
                        on: { click: _vm.discardJob }
                      },
                      [
                        _vm._v("\n          Discard\n          "),
                        _c("div", { staticClass: "ld ld-ball ld-flip" })
                      ]
                    ),
                    _vm._v(" "),
                    _vm.$_can("jobs.update")
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-primary ld-ext-right",
                            class: _vm.loadingButton ? "running" : "",
                            attrs: { disabled: _vm.buttonDisabled }
                          },
                          [
                            _vm._v("\n          Save\n          "),
                            _c("div", { staticClass: "ld ld-ball ld-flip" })
                          ]
                        )
                      : _vm._e()
                  ])
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.showMessagesModal === true && _vm.carrierPhoneNumberCheck()
        ? _c("messages", {
            attrs: {
              "carrier-id": _vm.job.carrier_id,
              "carrier-number": _vm.job.carrier.phone_numbers.find(function(
                num
              ) {
                return num.type.id === 2
              }).phone_number,
              model: "jobs",
              "model-id": _vm.job.id,
              "selected-mover": _vm.selectedMoverId,
              "assigned-movers": _vm.job.assigned_movers
            },
            on: { toggleShowMessagesModal: _vm.toggleShowMessagesModal }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h2", { staticClass: "mt-4 mb-2 documents-title" }, [
        _vm._v("Documents")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "pl-0", attrs: { scope: "col" } }, [
          _vm._v("Name")
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "pl-0", attrs: { scope: "col" } }, [
          _vm._v("Status")
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "pl-0", attrs: { scope: "col" } }),
        _vm._v(" "),
        _c("th", { staticClass: "pl-0", attrs: { scope: "col" } }, [
          _vm._v("Phone")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "send-to-all" }, [
      _c("i", { staticClass: "fa fa-ellipsis-h" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "pl-0", attrs: { scope: "col" } }, [
          _vm._v("Licence plate")
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "pl-0", attrs: { scope: "col" } }, [
          _vm._v("Name")
        ]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "mr-2" }, [
      _c("span", { staticClass: "mod-icon-add" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "mr-2" }, [
      _c("span", { staticClass: "mod-icon-add" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d1bff1c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d1bff1c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/JobsTabsContent.vue
// module id = null
// module chunks = 